import React from 'react'

export const Footer = () => {
  return (
    <div className="footer">
        <footer>
            <p>Created by <a href="https://github.com/claudi-aaa/chat-project/tree/main/chat-app">claudi-aaa</a> 💜</p>
        </footer>

    </div>
  )
}


